import React from 'react';
import { BaseURLImageFormatter, IBaseComponentProps, NSCopy } from '../main';
import { BaseUUID, CacheService, IStorage } from 'namirasoft-core';
import { NamirasoftMap } from 'namirasoft-site-map';
import { NSBaseMetaTable, NSBaseServer } from 'namirasoft-site';
import { Mutex } from 'async-mutex';

export interface NSIDProps extends IBaseComponentProps
{
	id: string;
	globe: NamirasoftMap | null;
	storage: IStorage | null;
}

export interface NSIDState
{
	text?: string;
}

export class NSID extends React.Component<NSIDProps, NSIDState>
{
	private static mutex: Mutex = new Mutex();
	private static mutexes: { [product_id: string]: Mutex } = {};
	private info?: {
		product: {
			id: string;
			name: string;
			headline: string;
			description: string;
			logo: string;
			link: string;
		};
		table: NSBaseMetaTable<NSBaseServer, any>;
	};
	constructor(props: NSIDProps)
	{
		super(props);
		this.state = {};
		try
		{
			let short = BaseUUID.getShort(this.props.id);
			let namriasoft = this.props.globe ?? new NamirasoftMap();
			this.info = namriasoft.getByShortName(short);
		} catch (error)
		{
		}
	}
	override componentDidMount(): void
	{
		this.reload();
	}
	async reload()
	{
		if (!this.info)
			return;
		if (!this.props.id)
			return;
		let info = this.info;
		let cache = null;
		if (this.props.storage)
		{
			cache = new CacheService<string>(info.product.id + ":" + info.table.name + ":" + this.props.id, this.props.storage, 60, async () => "0.0.0", async () =>
			{
				if (info.table.back_end.get)
				{
					try
					{
						let columns: string[] = [];
						info.table.forEachColumn(column =>
						{
							if (column.name.includes("name"))
								columns.push(column.name);
						});
						let row = await info.table.back_end.get(this.props.id);
						let values = columns.map(column => row[column]).filter(x => x);
						if (values.length > 0)
							return values.join(" ");
						return row.name ?? row.description ?? "";
					} catch (error)
					{
						console.error(error);
					}
				}
				return "";
			});
			cache.runGetOn = await NSID.mutex.runExclusive(async () =>
			{
				if (!NSID.mutexes[info.product.id])
					NSID.mutexes[info.product.id] = new Mutex();
				return NSID.mutexes[info.product.id];
			});
		}
		if (cache)
			cache.get().then(text =>
			{
				this.setState({ text });
			});
	}

	override render()
	{
		if (!this.props.id)
			return <></>;
		if (!this.info)
			return this.props.id;

		let text = this.state.text;
		if (!text)
			text = this.props.id;

		let href = "";
		try
		{
			href = this.info.table.front_end.getViewLink(this.props.id + "");
		} catch (error)
		{
		}
		let formatter = new BaseURLImageFormatter();
		return (
			<NSCopy
				value={this.props.id}
				classList={["justify-content-start"]}
			>
				{
					formatter.format({
						text,
						href,
						image: { url: this.info.product.logo, alt: this.info?.product.logo }
					})
				}
			</NSCopy>
		);
	}
}